import { useState } from "react";
import ReactSwitch from "react-switch";
import Layout from "../layouts/layout";
import Filter from "../sections/_orders/Filter";
import Table from "../sections/_orders/Table";
import styles from "../styles/_screens/orders.module.scss";

const Orders = () => {
  const [checked, setChecked] = useState(false);

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <h1>Orders</h1>

          <Filter />

          <div className={styles.archiveCheck}>
            <ReactSwitch
              onChange={() => setChecked(!checked)}
              checked={checked}
              checkedIcon={false}
              uncheckedIcon={false}
              offColor={"#fff"}
              offHandleColor={"#E5E4E2"}
              handleDiameter={16}
              className="smallSwitch"
              width={45}
              height={22}
            />
            Move to archive
          </div>

          <Table />
        </div>
      </div>
    </Layout>
  );
};

export default Orders;
